<template>
  <router-view :context="'landlord'" />
</template>
<script>
export default {
  data() {
    return {
      current: false
    }
  },
  mounted() {
    this.current = this.$route.query.current

    this.$router.replace({ name: "flow_listing_verify_disclaimer" })
  }
}
</script>
